import React, { useState } from 'react';

export default function NavelVenueCard({ venue, alternatives, city, copyToClipboard }) {
  const [showAlt, setShowAlt] = useState(false);
  const alt = alternatives[venue.venueName];

  const searchUrl = venue.searchQuery
    ? `https://www.google.com/search?q=${venue.searchQuery}`
    : `https://www.google.com/search?q=${encodeURIComponent(venue.venueName + ' ' + city)}`;

  return (
    <div className="navel-venue">
      {/* Header row: name + time badge */}
      <div className="navel-venue-header">
        <div style={{ flex: 1 }}>
          <h3 className="navel-h3" style={{ marginBottom: 6 }}>{venue.heading}</h3>
          <a href={searchUrl} target="_blank" rel="noopener noreferrer" className="navel-small" style={{ display: 'block' }}>
            {venue.address}
          </a>
        </div>
        {venue.time && <span className="navel-venue-time">{venue.time}</span>}
      </div>

      {/* Star rating badge */}
      {venue.rating && (
        <div style={{ marginBottom: 14 }}>
          <span className="navel-star-badge" style={{ fontSize: '0.6875rem', padding: '4px 10px' }}>
            ★ {venue.rating}
          </span>
        </div>
      )}

      {/* Description */}
      {venue.description && (
        <p className="navel-body" style={{ marginBottom: 14 }}>{venue.description}</p>
      )}

      {/* Price */}
      <p className="navel-small" style={{ fontWeight: 600 }}>
        {venue.priceLabel || 'Prices'}: {venue.prices}
      </p>

      {/* Actions row */}
      <div style={{ display: 'flex', gap: 8, marginTop: 16, flexWrap: 'wrap' }}>
        {venue.address && (
          <button onClick={() => copyToClipboard(venue.address)} className="navel-btn-secondary" style={{ padding: '6px 14px', fontSize: '0.6875rem' }}>
            Copy address
          </button>
        )}
        {alt && (
          <button onClick={() => setShowAlt(!showAlt)} className="navel-btn-secondary" style={{ padding: '6px 14px', fontSize: '0.6875rem' }}>
            {showAlt ? 'Hide' : 'Show'} alternative
          </button>
        )}
      </div>

      {/* Alternative venue */}
      {alt && showAlt && (
        <div className="navel-venue-alt">
          <p style={{ fontWeight: 700, color: 'var(--text-primary)', fontFamily: 'var(--font-heading)', fontSize: '1.05rem', marginBottom: 6 }}>
            {alt.name}
          </p>
          <a
            href={`https://www.google.com/search?q=${encodeURIComponent(alt.name + ' ' + alt.address + ' ' + city)}`}
            target="_blank" rel="noopener noreferrer"
            className="navel-small" style={{ display: 'block', marginBottom: 10 }}
          >
            {alt.address}
            <button
              onClick={(e) => { e.preventDefault(); copyToClipboard(alt.address); }}
              style={{ marginLeft: 8, background: 'none', border: 'none', cursor: 'pointer', color: 'var(--color-accent)', fontSize: '0.6875rem', fontFamily: 'var(--font-body)' }}
            >
              Copy
            </button>
          </a>
          <p className="navel-body" style={{ marginBottom: 6 }}><strong style={{ color: 'var(--text-primary)' }}>Why:</strong> {alt.why}</p>
          <p className="navel-body" style={{ marginBottom: 6 }}>
            <strong style={{ color: 'var(--text-primary)' }}>{alt.dishes ? 'Dishes' : 'Drinks'}:</strong> {alt.dishes || alt.drinks}
          </p>
          <p className="navel-body"><strong style={{ color: 'var(--text-primary)' }}>Prices:</strong> {alt.prices}</p>
        </div>
      )}
    </div>
  );
}
